
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import ProductButton from '@/components/ProductButton.vue';
import Background from '@/components/Background.vue';
import { CategoryData, ProductInput, ProductData } from '@/types';
import AppButton from "@/components/AppButton.vue";
import Accordion from "@/components/Accordion.vue";

@Component({
	components: {
		Accordion,
		AppButton,
		ProductButton,
		Background
	}
})
export default class ProductSelector extends Vue {
	@Prop() itemsInList!: number[];
	private selectedItems: string[] = [];
	private showCategories: boolean = true;
	private categoryAccordionOpen: Record<number, boolean> = {};

	private get label(): string {
		return this.$store.state.currentTheme.label;
	}

	private get prioritizedItems(): ProductData[] {
		let items: ProductData[] = [];

		for (const itemId of this.$store.state.currentTheme.prioritizedItemIds) {
			items.push(this.$store.state.items[itemId]);
		}

		return items.sort((a, b) => a.label.localeCompare(b.label));
	}

	private get categories(): CategoryData[] {
		const categories: CategoryData[] = Object.values(this.$store.state.categories);

		return categories.sort((a, b) => {
			// Sort by prioritizationLevel first, with nulls at the end
			if (a.prioritizationLevel === null && b.prioritizationLevel !== null) return 1;
			if (a.prioritizationLevel !== null && b.prioritizationLevel === null) return -1;
			if (a.prioritizationLevel !== null && b.prioritizationLevel !== null) {
				const priorityDifference = a.prioritizationLevel - b.prioritizationLevel;
				if (priorityDifference !== 0) return priorityDifference;
			}

			// If prioritizationLevel is the same (including both null), sort by label alphabetically
			return a.label.localeCompare(b.label);
		});
	}


	private isAccordionOpen(categoryId: number): boolean {
		const isOpen = this.categoryAccordionOpen?.[categoryId] || false;
		return isOpen;
	}

	private openCategoryAccordion(categoryId: number): void {
		const isOpen = this.categoryAccordionOpen?.[categoryId] || false;
		this.$set(this.categoryAccordionOpen, categoryId, !isOpen);
	}

	private getCategoryItems(categoryId: number): ProductData[] {
		const itemIds: number[] = this.$store.state.categories[categoryId].itemIds;
		const items: ProductData[] = [];
		for (const id of itemIds) {
			items.push(this.$store.state.items[id]);
		}
		return items.sort((a, b) => a.label.localeCompare(b.label));
	}

	private toggleShowCategories(): void {
		this.showCategories = !this.showCategories;
	}

	private handleItemSelection(item: string, selected: boolean): void {
		if (selected && !this.selectedItems.includes(item)) {
			this.selectedItems.push(item);
		} else {
			this.selectedItems = this.selectedItems.filter((i) => i != item);
		}
	}

	@Emit()
	private close(): string[] {
		return this.selectedItems;
	}
}
